import React from 'react';

import CachedIcon from '@material-ui/icons/Cached';
import Chip from '@material-ui/core/Chip';
import Tooltip from '@material-ui/core/Tooltip';
import Zoom from '@material-ui/core/Zoom';

export const Cache = ({ ultimaAtualizacao, action, label = "Atualizar Agora" }) => {
    return (
        <Chip
            style={{ marginLeft: 12 }}
            label={ultimaAtualizacao ? `Última Atualização: ${ultimaAtualizacao}` : label }
            deleteIcon={<Tooltip title={"Atualizar Agora"} TransitionComponent={Zoom}><CachedIcon /></Tooltip>}
            onDelete={action}
        />
    )
}

export default Cache;